export { GuidedTour } from './GuidedTour';
export { GuidedTourProvider, useGuidedTour, GuidedTourContext } from './GuidedTourProvider';
export { GuidedTourOverlay } from './GuidedTourOverlay';
export { GuidedTourIndex } from './GuidedTourIndex';
export { GuidedTourWelcomeOverlay } from './GuidedTourWelcomeOverlay';
export { GuidedTourObjectiveIndex } from './GuidedTourObjectiveIndex';
export { GuidedTourFormatPicker } from './GuidedTourFormatPicker';
export { GuidedTourRunner } from './GuidedTourRunner';
export { TourChatPanel } from './TourChatPanel';
export { GuidedTourVideoCard } from './GuidedTourVideoCard';
export { GuidedTourQuickGuide } from './GuidedTourQuickGuide';
export { GuidedTourMinimized } from './GuidedTourMinimized';
export { GuidedTourCelebration } from './GuidedTourCelebration';
export { GuidedTourFeedback } from './GuidedTourFeedback';
export { GuidedTourLauncher } from './GuidedTourLauncher';
export { GuidedTourSandbox } from './GuidedTourSandbox';
export { TourPrompt, type TourPromptConfig, type TourPromptFlowInfo } from './TourPrompt';
export { default as TourAnalyticsDashboard } from './TourAnalyticsDashboard';

// Re-export ViewScope from the canonical types
export type { ViewScope } from '@/config/guided-tours/types';

export { useTourSandbox } from './hooks/useTourSandbox';
export type { UseTourSandboxReturn } from './hooks/useTourSandbox';

export { useTourEngine } from './hooks/useTourEngine';
export { useTourConfig } from './hooks/useTourConfig';
export { useTourProgress } from './hooks/useTourProgress';
export { useTourSpotlight } from './hooks/useTourSpotlight';
export { useTourMascot } from './hooks/useTourMascot';
export { useTourTTS } from './hooks/useTourTTS';
export type { UseTourTTSOptions, UseTourTTSResult } from './hooks/useTourTTS';
export { useTourChat } from './hooks/useTourChat';
export type { TourChatMessage, UseTourChatOptions, UseTourChatResult } from './hooks/useTourChat';
export {
  useTourVerification,
  emitGuidedTourTrainingEvent,
  GUIDED_TOUR_TRAINING_EVENT,
  GUIDED_TOUR_DISMISS_REVEAL_EVENT,
} from './hooks/useTourVerification';

export {
  resolveFlowFormats,
  resolveModuleFormats,
  resolveStepFormat,
  pickBestFormat,
  TOUR_FORMATS,
} from './utils/formatResolver';
export type { TourFormat, FlowFormatResolution } from './utils/formatResolver';

export {
  buildMascotChoreography,
  getIndexChoreography,
  getCelebrationChoreography,
  getStepChoreography,
} from './utils/mascotChoreography';
export type {
  MascotChoreography,
  MascotDockPosition,
  MascotPointerDirection,
} from './utils/mascotChoreography';
